(function () {
    'use strict';

    angular
        .module('app')
        .component('obraMuseoFormAdmin', {
            templateUrl: 'app/components/aspg/museos/admin/obramuseo/obra-museo-form.admin.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                item: '<',
                previousParams: '<'
            }
        });

    /* @ngInject */
    function Controller($rootScope, $timeout, $state, $stateParams, ModalService, MuseosUtil) {
        var vm = this;

        $timeout(function () {
            angular.element('.form-group:eq(0) input').focus();
        });

        vm.mode = $state.current.data.mode;
        vm.canSave = vm.mode === 'create' || vm.mode === 'edit';

        vm.urlBaseImagen = MuseosUtil.getRutaObras(vm.item.id);

        function init() {
            if (!vm.item.museo) {
                vm.item.sala = {id: $stateParams.salaid};
            }
        }

        // Guardar formulario
        vm.save = function () {
            vm.item.$save().then(function () {
                ModalService.closeComponent(vm.item, 'admin/museos/obraMuseo/list', vm.previousParams);
            }).catch(function (response) {
                $rootScope.mostrarErrores(response, vm.form);
            });
        };

        init();

    }

})();
